<template>
	<div class="list-item">
		<section class="wrap">
			<div class="infos">
				<h2 class="raison_sociale"> <i v-if="detenteur.type == 'Particulier' || detenteur.type == null"
						class="icon-user"></i> <img v-if="detenteur.type == 'Société'"
						style="width: 13px; display: inline; margin: 0 6px 0 4px" src="../../img/building-regular.svg"
						class="icon-building">{{ detenteur.raison_sociale }} <span v-if="detenteur.code_client">- {{
							detenteur.code_client }}</span></h2>
				<h3>{{ detenteur.adresse }}<br />{{ detenteur.code_postal }} {{ detenteur.ville }}</h3>

				<a v-if="detenteur.telephone" class="tel btn btn-wire" :href="linkTel">
					<i class="icon-phone"></i>
					<span>{{ detenteur.telephone }}</span>
				</a>

				<h3>{{ detenteur.nom }}</h3>

				<a v-if="detenteur.portable" class="tel btn btn-wire" :href="linkMobile">
					<i class="icon-phone"></i>
					<span>{{ detenteur.portable }}</span>
				</a>
			</div>

			<nav>
				<div class="actions">
					<div class="btn btn-full goto" @click="goToGPS(detenteur)">
						<i class="icon-car"></i>
					</div>
					<router-link class="btn edit btn-full" :to="linkDetenteur">
						<i class="icon-edit"></i>
					</router-link>
				</div>

				<div class="tdInfo" v-if="statutTD">
					<template v-if="estOkTD">
						<div class="tdBadges">
							<span class="tdText tdOk">OK TRACKDECHETS</span>
							<span v-if="infoTD" class="tdText tdMaybe tdSousBadge">{{ infoTD }}</span>
						</div>
						<img class="logoTD" :src="urlTD" alt="Logo TrackDéchets">
					</template>
					<span v-else class="tdText" :class="classeStatutTD">{{
						statutTD.libelle }}</span>
				</div>

				<router-link class="btn install btn-full" :to="linkInstallations">
					<span>Voir les</span>
					<strong>installations</strong>
					<i class="icon-go"></i>
				</router-link>
			</nav>
		</section>
	</div>
</template>

<script>
import Config from "../../js/config";

export default {
	data() {
		return {
			urlTD: Config.urlAdmin + '/img/trackdechets.png'
		}
	},
	props: {
		detenteur: {

		},
		typeuser: null
	},
	computed: {
		/**
		 * Statut résolu par l'API (MD-528). Auparavant l'application réinterprétait le code
		 * brut de son côté, avec des conditions qui se déclenchaient simultanément : un
		 * détenteur non inscrit affichait « OK TRACKDECHETS » et « NON INSCRIT » à la fois.
		 *
		 * Rien n'est affiché si l'API ne fournit pas le statut, plutôt que de revenir à une
		 * interprétation locale qui redeviendrait une seconde source de vérité.
		 */
		statutTD: function () {
			return this.detenteur.statut_trackdechets || null
		},
		/**
		 * Un code postal différent n'empêche pas l'usage de TrackDéchets : l'établissement y
		 * est bien trouvé, l'écart n'est qu'une information à corriger.
		 */
		estOkTD: function () {
			return !!this.statutTD
				&& (this.statutTD.niveau === 'conforme' || this.statutTD.cle === 'CODE_POSTAL_DIFFERENT')
		},
		infoTD: function () {
			return this.statutTD && this.statutTD.cle === 'CODE_POSTAL_DIFFERENT' ? 'Code postal différent' : null
		},
		classeStatutTD: function () {
			if (!this.statutTD) {
				return null
			}

			switch (this.statutTD.niveau) {
				case 'bloquant':
					return 'tdKo'
				case 'a_verifier':
					return 'tdMaybe'
				default:
					return 'tdInfoBadge'
			}
		},
		linkDetenteur: function () {
			return 'detenteur/' + this.detenteur.id
		},
		linkInstallations: function () {
			return this.linkDetenteur + '/installations/'
		},
		linkTel: function () {
			return 'tel:' + this.detenteur.telephone
		},
		linkMobile: function () {
			return 'tel:' + this.detenteur.portable
		}
	},
	mounted: function () {

	},

	methods: {
		goToGPS(detenteur) {
			if (detenteur) {
				let address = detenteur.adresse + (detenteur.complement_adresse ? ' ' + detenteur.complement_adresse : '') + ' ' + detenteur.code_postal + ' ' + detenteur.ville;
				let lat = detenteur.lat;
				let lng = detenteur.lng;

				if (lat && lng && address) {
					swal({
						title: "Enregistrer la localisation",
						text: "Voulez vous suivre l'adresse du détenteur ou sa position ?",
						type: "question",
						confirmButtonText: "Adresse",
						cancelButtonText: "Position",
						showCancelButton: true,
					}).then((result) => {
						if (window.isMobile()) {
							if (typeof window.flutter_inappwebview !== 'undefined' && window.flutter_inappwebview !== null) {
								if (result == true) {
									window.flutter_inappwebview.callHandler('goTo', 'address', address);
								}
							}
						}
					}, (result) => {
						if (window.isMobile()) {
							if (typeof window.flutter_inappwebview !== 'undefined' && window.flutter_inappwebview !== null) {
								if (result == 'cancel') {
									window.flutter_inappwebview.callHandler('goTo', 'latlng', lat, lng, detenteur.raison_sociale);
								}
							}
						}
					});
				} else {
					if (window.isMobile()) {
						if (typeof window.flutter_inappwebview !== 'undefined' && window.flutter_inappwebview !== null) {
							window.flutter_inappwebview.callHandler('goTo', 'address', address);
						}
					}

				}
			}
		},
	}
}
</script>

<style>
#detenteurs-items .list-item {
	background-color: #eee;
	padding: 10px 0;
	margin-bottom: 10px;
}

/* Carte en deux colonnes dans le flux : les infos ne peuvent plus passer sous les boutons */
#detenteurs-items .list-item section {
	display: flex;
	min-height: 178px;
}

#detenteurs-items .list-item .infos {
	flex: 1 1 auto;
	min-width: 0;
}

#detenteurs-items .list-item nav {
	flex: 0 0 175px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-end;
	margin-left: 10px;
}

#detenteurs-items .list-item nav .actions {
	display: flex;
	margin-top: 10px;
	margin-bottom: 10px;
}

#detenteurs-items .list-item section h2 {
	font-size: 2rem;
	color: #000;
	overflow-wrap: break-word;
}

#detenteurs-items .list-item section h2 span {
	color: #5698d2;
	font-size: 1.8rem;
}

#detenteurs-items .list-item section h3 {
	color: #666;
	text-transform: none;
	font-size: 1.4rem;
	margin-top: 5px;
	overflow-wrap: break-word;
}

#detenteurs-items .list-item section .tel {
	margin-top: 5px;
	max-width: 100%;
	white-space: nowrap;
}

#detenteurs-items .list-item section .tel span {
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
}

#detenteurs-items .list-item nav .goto {
	height: 40px;
	width: 50px;
	margin-right: 10px;
	font-size: 3rem;
	padding-left: 4.5px;
	cursor: pointer;
}

#detenteurs-items .list-item nav .install {
	width: 175px;
	font-size: 1.1rem;
	padding-left: 10px;
}

#detenteurs-items .list-item .tdInfo {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	max-width: 100%;
	margin-bottom: 10px;
	text-align: right;
}

.tdBadges {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	min-width: 0;
}

.tdSousBadge {
	margin-top: 3px;
}

.logoTD {
	display: block;
	flex-shrink: 0;
	max-width: 50px;
	margin-left: 5px;
}

.tdText {
	display: inline-block;
	max-width: 100%;
	padding: 5px 10px;
	font-weight: bold;
	font-size: 10px;
	line-height: 1.3;
	white-space: normal;
	text-align: center;
}

#detenteurs-items .btn.edit i {
	color: white;
}

#detenteurs-items .btn.edit {
	color: white;
	background-color: #5698d2;
}

#detenteurs-items .btn.edit:hover {
	background-color: #333;
}

.tdOk {
	background: #92D050;
	box-shadow: 2px 2px 3px rgba(169, 169, 169, 0.5);
}

.tdMaybe {
	background: #FFC000;
	box-shadow: 2px 2px 3px rgba(255, 192, 0, 0.6);
}

.tdKo {
	color: white;
	background: #FF0000;
	box-shadow: 2px 2px 3px rgba(255, 0, 0, 0.6);
}

.tdInfoBadge {
	color: white;
	background: #306FC9;
	box-shadow: 2px 2px 3px rgba(48, 111, 201, 0.6);
}

/* Petits écrans : on réduit la colonne des boutons pour laisser la place aux numéros de téléphone */
@media (max-width: 380px) {
	#detenteurs-items .list-item nav {
		flex-basis: 150px;
	}

	#detenteurs-items .list-item nav .install {
		width: 150px;
	}

	#detenteurs-items .list-item nav .install strong {
		font-size: 1.25rem;
	}
}

@media (max-width: 340px) {
	#detenteurs-items .list-item nav {
		flex-basis: 135px;
	}

	#detenteurs-items .list-item nav .install {
		width: 135px;
	}

	#detenteurs-items .list-item nav .install strong {
		font-size: 1.1rem;
	}

	#detenteurs-items .list-item section .tel {
		font-size: 1.6rem;
	}
}
</style>



// WEBPACK FOOTER //
// DetenteurItem.vue?4a7af9a8